var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoRef",attrs:{"controls":"","preload":"auto"},on:{"play":_vm.playVideo,"pause":_vm.pauseVideo,"dblclick":_vm.toggleFullScreen}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}}),_vm._v("\n    视频加载失败(西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5017ea1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/VideoPlayer.vue
// module id = null
// module chunks = 